module.exports = __webpack_public_path__ + "static/media/T-shirt_light.c8bccc81.svg";